const { fetcher } = require('services/helpers/responseHandler')

const getRateCodes = async ({ isSubsidiaryLevel } = {}) => {
  const params = {}
  if (isSubsidiaryLevel) {
    params.isSubsidiaryLevel = isSubsidiaryLevel
  }

  return await fetcher.get('subsidiaries/rateCodes', params)
}

const putRateCodes = async ({ rateCodes }) =>
  await fetcher.put('subsidiaries/rateCodes', rateCodes)

const getPromoCodes = async () => await fetcher.get('subsidiaries/promoCodes')

const getHotelList = async ({ type, refreshStatus = false }) =>
  await fetcher.get('subsidiaries', { kind: type, refreshCache: refreshStatus })

const enableAutoInvite = async ({ subsidiaryId }) =>
  await fetcher.post('subsidiaries/update/invite-back/bulk', {
    subsidiariesToUnBlock: [subsidiaryId],
    reason: '-'
  })

const disableAutoInvite = async ({ subsidiaryId, reason }) =>
  await fetcher.post('subsidiaries/update/invite-back/bulk', {
    subsidiariesToBlock: [subsidiaryId],
    reason
  })

const getSitemap = async () => await fetcher.get('subsidiaries/sitemaps')

const autoresponses = async () => await fetcher.get('subsidiaries/autoresponses')

const updateAutoresponses = async autoresponses =>
  await fetcher.post('subsidiaries/autoresponses', autoresponses)

const updateStatus = async ({ reason, status }) =>
  await fetcher.patch('merchants/subsidiary/status', { reason, status })

const getHotelTags = async () => await fetcher.get('subsidiaries/tags')

const updateHotelTags = async ({ tags }) => await fetcher.post('subsidiaries/tags', tags)

const getHotelTagDefinitions = async () =>
  await fetcher.get('subsidiaries/tags/definitions')

const getCSMTags = async () => await fetcher.get('subsidiaries/csmtags')

const updateCSMTags = async ({ tags }) => await fetcher.post('subsidiaries/csmtags', tags)

const getCSMTagDefinitions = async () =>
  await fetcher.get('subsidiaries/csmtags/definitions')

const rateCodeUsage = async rateCode =>
  await fetcher.get('subsidiaries/usage-rate-code', { rateCode })

const getPrepayPeriod = async () => await fetcher.get('subsidiaries/prepay-period')

const postPrePayPeriod = async data =>
  await fetcher.post('subsidiaries/prepay-period', data)

const getHotelSetupLoginLink = async ({ subsidiaryId, userId, isSendEmail = false }) =>
  await fetcher.post('login/shared-link', {
    subsidiaryId: subsidiaryId,
    sharedToUserId: userId,
    isSendEmail
  })

const findHotelByInvoiceId = async ({ invoiceId }) =>
  await fetcher.get('subsidiaries/find', { invoiceId })

const getDomain = async () => await fetcher.get('subsidiaries/domain')

const updateDomain = async ({ subdomain, domain, landingPageDomainPreference }) =>
  await fetcher.post('subsidiaries/domain', {
    subdomain,
    domain,
    landingPageDomainPreference
  })

const checkDnsRecord = async ({ domain }) =>
  await fetcher.get('subsidiaries/domain/cname-records-check', { domain })

const getReferrers = async () => await fetcher.get('subsidiaries/referrers')

const remindLater = async ({ subsidiaryId, remindLaterReason, remindLaterAfter }) =>
  await fetcher.post('subsidiaries/remind-later-update', {
    subsidiaryId,
    remindLaterReason,
    remindLaterAfter
  })

const hotelConfiguration = async () =>
  await fetcher.get('subsidiaries/hotel-configuration-stage')

const hotelConfigurationStatus = async () =>
  await fetcher.get('subsidiaries/hotel-configuration-stage-retrieve')

const switchToPrepay = async data =>
  await fetcher.post('subsidiaries/postpay-to-prepay/switch', data)

const managePlan = async payload =>
  await fetcher.post('subsidiaries/manage-plan', payload)

const upgradeToUnlimited = async data =>
  await fetcher.post('subsidiaries/addsubscription', data)

const subsidiariesApi = {
  getHotelList,
  enableAutoInvite,
  disableAutoInvite,
  getSitemap,
  updateStatus,
  remindLater,
  hotelConfiguration,
  hotelConfigurationStatus,
  referrers: {
    get: getReferrers
  },
  prepayPeriod: {
    get: getPrepayPeriod,
    post: postPrePayPeriod
  },
  rateCodes: {
    get: getRateCodes,
    put: putRateCodes
  },
  promoCodes: { get: getPromoCodes },
  autoresponses: {
    get: autoresponses,
    update: updateAutoresponses
  },
  hotelTags: {
    get: getHotelTags,
    update: updateHotelTags,
    definitions: {
      get: getHotelTagDefinitions
    }
  },
  csmTags: {
    get: getCSMTags,
    update: updateCSMTags,
    definitions: {
      get: getCSMTagDefinitions
    }
  },
  rateCodeUsage,
  find: {
    byInvoiceId: findHotelByInvoiceId
  },
  getHotelSetupLoginLink,
  domain: {
    get: getDomain,
    update: updateDomain,
    checkDnsRecord
  },
  switchToPrepay,
  managePlan,
  upgradeToUnlimited
}

export default subsidiariesApi
